import React, { useMemo } from 'react';
import {
  Person,
  UpdateOwnProfileRequest,
  useAuthenticationContextRequired,
  usePeopleService
} from 'nekst-api';
import { InformationMessage } from 'features/nekst-widgets';
import {
  FormTemplate,
  SubmitButton,
} from 'ui-builder';
import { UpdatePersonFormFields } from '../People';

function CompleteAccountMessage() {
  const authenticationContext = useAuthenticationContextRequired();

  if (authenticationContext && !authenticationContext.user.hasActiveAccount) {
    return (
      <InformationMessage>
        Thank you for registering! To complete your profile, please fill out the form below.
      </InformationMessage>
    );
  } else {
    return null;
  }
}

export function UpdateProfileForm(
  props: {
    hideTitle?: boolean,
    onAccountCompleted?: () => void,
  }
) {
  const authenticationContext = useAuthenticationContextRequired();
  const peopleService = usePeopleService();
  const isAccountCompleted = authenticationContext.user.hasActiveAccount;

  const teamRole = authenticationContext.user.teamRole;

  const initialData = useMemo(() => {
    return {
      profile: authenticationContext.user.profile,
      isDailyMailEnabled: authenticationContext.user._user.isDailyMailEnabled,
    }
  }, []);

  return (
    <FormTemplate<UpdateOwnProfileRequest, Person>
      submitFormFunc={async (data) => {
        const result = await peopleService.updateOwnProfile(data);

        if (!isAccountCompleted) {
          props.onAccountCompleted?.();
        }

        return result;
      }}
      initialData={initialData}
      buttons={(
        <SubmitButton text="Update" />
      )}
      title={!props.hideTitle ? 'Profile' : undefined}
      validationSchema={() => peopleService.getUpdateValidationSchema(teamRole)}
    >
      <CompleteAccountMessage />
      <UpdatePersonFormFields person={authenticationContext.user} />
    </FormTemplate>
  );
}
